import { MasterDataEntityPage } from "../MasterDataEntityPage"
import { MasterDataPanelLayout } from "../MasterDataPanelLayout"
import { CustomerDetailPanel } from "../customers/CustomerDetailPanel"
import { CustomerListPanel } from "../customers/CustomerListPanel"
import { useRowMultiSelect } from "../useRowMultiSelect"

export function CustomersPage() {
  const { selectedIds, toggleSelected, removeIds } = useRowMultiSelect()

  return (
    <MasterDataEntityPage titleKey="MC_MD_TAB_CUSTOMERS">
      <MasterDataPanelLayout
        listPanel={
          <CustomerListPanel
            selectedIds={selectedIds}
            onToggleSelected={toggleSelected}
          />
        }
        detailPanel={
          <CustomerDetailPanel
            selectedIds={selectedIds}
            onRemoveIds={removeIds}
          />
        }
      />
    </MasterDataEntityPage>
  )
}
